import DashboardIcon from "@mui/icons-material/Dashboard";
import { Grid, Typography } from "@mui/material";
import ChartProvider from ".";
import LoadingWrapper from "../loading";

import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChartCustom = ({
  title,
  data = [],
  loading = false,
  colors = [],
  className = "",
}) => {
  const [state, setState] = useState({
    chart: { labels: [], datasets: [] },
  });

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      const labels = data.map((item) => item.name);

      // const datasets = data.map((sere, index) => ({
      //   label: sere.name,
      //   data: [sere.value],
      //   borderColor: colors[index],
      //   backgroundColor: colors[index],
      // }));

      let dataset = {
        label: "",
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
      };

      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        dataset.data.push(item.value);
        dataset.backgroundColor.push(ChartProvider.renderColor(colors, i));
        dataset.borderColor.push(ChartProvider.renderColor(colors, i));
      }

      setState((old) => ({
        ...old,
        chart: {
          labels,
          datasets: [dataset],
        },
      }));
    }
  }, [data]);

  return (
    <Grid
      container
      style={{ direction: "ltr", minHeight: 250 }}
      justifyContent="center"
      alignItems="center"
      className={clsx(className)}
    >
      {loading ? (
        <Grid
          item
          xs={12}
          md={12}
          container
          justifyContent="center"
          alignItems="center"
        >
          <LoadingWrapper />
        </Grid>
      ) : Array.isArray(data) && data.length > 0 ? (
        <>
          <Grid item xs={12} md={12}>
            <Typography textAlign={"center"} variant="h6" fontWeight={"bold"}>
              {title}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            xl={12}
            container
            justifyContent="center"
            alignItems="center"
          >
            <Doughnut
              data={state.chart}
              height={200}
              width={"100%"}
              options={{
                aspectRatio: 1.6,
                // radius: 100,
                // responsive: true,
                maintainAspectRatio: true,
                legend: { display: true, position: "right" },
                datalabels: {
                  display: true,
                  color: "white",
                },
                tooltips: {
                  backgroundColor: "#5a6e7f",
                },
              }}
            />
          </Grid>
        </>
      ) : (
        <Grid
          item
          xs={12}
          md={12}
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <DashboardIcon sx={{ fontSize: "8rem", mb: 3 }} color="gray" />
          <Typography color="gray" variant="h6" fontWeight="bold">
            داده ای جهت نمایش وجود ندارد
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default PieChartCustom;
